'use strict'

require 'grpn-ls-polyfills/lib/polyfills-prod'
